import * as Sentry from '@sentry/react'

// Initialise Sentry error + performance monitoring for the web app.
//
// The DSN is public (it ships in the client bundle) and comes from VITE_SENTRY_DSN
// so it can differ per environment / stay out of git like the Supabase keys. When
// it's absent (e.g. a contributor without the .env) Sentry stays inert rather than
// throwing, so the app still runs.
//
// Quota note: we're on the free Developer plan (a shared monthly error quota), so
// tracing is sampled low and Session Replay is left off to avoid burning through it.
// Bump `tracesSampleRate` (and add replay integrations) later if the plan allows.
const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined

export function initSentry() {
  if (!dsn) return

  Sentry.init({
    dsn,
    // Distinguishes prod events from local dev in the Sentry UI.
    environment: import.meta.env.PROD ? 'production' : 'development',
    // Tie errors to the app version (surfaced in Settings) so a spike can be
    // pinned to a release. Source maps are uploaded against this same release.
    release: import.meta.env.VITE_APP_VERSION as string | undefined,
    integrations: [Sentry.browserTracingIntegration()],
    // Sample performance traces lightly in prod; capture everything in dev.
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    // Don't report the noisy local dev double-invokes etc. to the shared quota
    // unless a DSN is explicitly wired for dev testing.
    enabled: true,
  })
}
